// Everything the show is made from: characters, places and props, newest or most recently painted with first.
// Tap one to change it, or make a new one.
import { useState } from "react";
import { useLibrary } from "../../library/store";
import { byRecent, type AssetKind } from "../../model/library";
import { AssetPage } from "./AssetPage";
import { startDraft } from "../../library/drafts";
import { Body, FigureCard, Icon, NewCard, Page, PlaceCard, Segmented, TopBar } from "../common";

const SECTIONS: { kind: AssetKind; title: string; newLabel: string }[] = [
  { kind: "character", title: "Characters", newLabel: "New character" },
  { kind: "background", title: "Places", newLabel: "New place" },
  { kind: "prop", title: "Props", newLabel: "New prop" },
];

export function LibraryPage({ onBack }: { onBack: () => void }) {
  const lib = useLibrary();
  const [editing, setEditing] = useState<string | null>(null);
  const [tab, setTab] = useState<AssetKind>("character");
  const s = SECTIONS.find(x => x.kind === tab)!;
  return (
    <Page className="library">
      <TopBar onBack={onBack} title="Characters, places and props" />
      <Body>
        <Segmented label="Show" value={tab} options={SECTIONS.map(x => [x.kind, x.title] as [AssetKind, string])} onChange={setTab} />
        <div className="pick-grid">
          <NewCard label={s.newLabel} onClick={() => setEditing(startDraft(s.kind))} />
          {lib.assets.filter(a => a.kind === s.kind).sort(byRecent).map(a => a.kind === "background"
            ? <PlaceCard key={a.id} assetId={a.id} onClick={() => setEditing(a.id)} />
            : <FigureCard key={a.id} assetId={a.id} onClick={() => setEditing(a.id)}
                sub={a.kind === "character" ? <><Icon name={a.voiceMode === "ai" ? "sparkle" : "mic"} size={14} /> {a.voiceMode === "ai" ? "AI voice" : "Your voice"}</> : undefined} />)}
        </div>
      </Body>
      {editing && <AssetPage key={editing} assetId={editing} onClose={() => setEditing(null)} />}
    </Page>
  );
}
